import { getSearchFields, getSearchFormConfig } from "./search-form.js";
import { getSearchParams, getSearchParamsHook, getSearchResultsHook } from "./search-api.js";
import { getSearchResultCol, getSearchResultCard, getSearchResultColProps, getSearchResultCardProps, getSearchResultMapFeatureProps } from "./search-results.js";

const config = {
  getId: () => "project",
  // UI
  getSearchFields,
  getSearchFormConfig,
  getSearchResultCol,
  getSearchResultCard,
  getSearchResultColProps,
  getSearchResultCardProps,
  getSearchResultMapFeatureProps,
  // Search API related
  getSearchParams,
  getSearchParamsHook,
  getSearchResultsHook,
}

export default config;
